import type { Vec3 } from '../types';
import { loadConfig } from './configService';
import { logEvent } from './debugLog';

/**
 * "Remember my parking spot" — a single personal, device-local pin (never
 * synced; it's the visitor's own data). Scoped to the map it was saved in.
 */

const KEY = 'navme.parking.v1';

export interface ParkingSpot {
  position: Vec3;
  mapCode: string;
  savedAt: number;
}

export function saveParkingSpot(position: Vec3): ParkingSpot {
  const spot: ParkingSpot = { position, mapCode: loadConfig().code, savedAt: Date.now() };
  localStorage.setItem(KEY, JSON.stringify(spot));
  logEvent('session', 'parking spot saved');
  return spot;
}

/** The saved spot, if any, and only if it belongs to the current map. */
export function getParkingSpot(): ParkingSpot | null {
  try {
    const spot = JSON.parse(localStorage.getItem(KEY) ?? 'null') as ParkingSpot | null;
    if (!spot) return null;
    if (spot.mapCode !== loadConfig().code) return null;
    return spot;
  } catch {
    return null;
  }
}

export function clearParkingSpot(): void {
  localStorage.removeItem(KEY);
  logEvent('session', 'parking spot cleared');
}
